import React, { Fragment } from "react";
import "./OrderDetails.css";
import Input from "../UI/Input";
import moment from "moment-timezone";
import SelectBoxDropDown from "../UI/SelectBoxDropDown";
import styled from "styled-components";
const ManualBookingResaonContainer = styled.div``;
const ManualBookingText = styled.p`
  padding-top: 5px;
`;
const GpOrderDetails = ({
    workFlowIdentifier,
    orderObj,
    comradErrorList,
    inputChangedHandler,
    gpOrderDetails,
    GpServicesToShowDoctorList,
    setPopupVisible,
    popupVisible,
    insuranceSelectionHandler,
    setGpOrderDetails,
    setShowCallStatusCode,
    setOrderObj,
    insuranceTypeList,
    conversationID,
    showCallStatusCode,
}) => {

    return (
        <Fragment>
            <div
                className={
                    workFlowIdentifier === "GP_WORKFLOW"
                        ? "section__separation1"
                        : "section__separation"
                }
            // style={{
            //   borderTop:
            //     workFlowIdentifier != "GP_WORKFLOW" && "1px solid lightgrey",
            // }}
            >
                <table>
                    <tr>
                        <td style={{ width: "5%", fontSize: "14" }} title={"First name"}>
                            FN:{" "}
                        </td>
                        <td>
                            <Input
                                id="firstname"
                                label="Given name"
                                elementType="input"
                                key="givenname"
                                name="first_name"
                                width="90%"
                                textTransform="capitalize"
                                placeholder="Ex. Clinton"
                                Value={orderObj.first_name}
                                onChange={(event) => {
                                    inputChangedHandler(event, "first_name");
                                }}
                                customStyle={{
                                    borderColor:
                                        Array.isArray(comradErrorList) &&
                                        comradErrorList.length > 0 &&
                                        comradErrorList[0] &&
                                        comradErrorList[0].patient_firstname &&
                                        comradErrorList[0].patient_firstname?.toLowerCase() !==
                                        orderObj.first_name.toLowerCase() &&
                                        "red",
                                }}
                                error_text={
                                    Array.isArray(comradErrorList) &&
                                    comradErrorList.length > 0 &&
                                    comradErrorList[0] &&
                                    comradErrorList[0].patient_firstname &&
                                    comradErrorList[0].patient_firstname?.toLowerCase() !==
                                    orderObj.first_name.toLowerCase() &&
                                    `First name in comrad is ${comradErrorList[0].patient_firstname}`
                                }
                            />
                        </td>
                        <td style={{ width: "5%", fontSize: "14" }} title={"Last name"}>
                            LN:{" "}
                        </td>
                        <td>
                            <Input
                                id="lastname"
                                key="surname"
                                label="Surname"
                                elementType="input"
                                name="last_name"
                                width="100%"
                                textTransform="capitalize"
                                placeholder="Ex. Marx"
                                Value={orderObj.last_name}
                                onChange={(event) => {
                                    inputChangedHandler(event, "last_name");
                                }}
                                customStyle={{
                                    borderColor:
                                        Array.isArray(comradErrorList) &&
                                        comradErrorList.length > 0 &&
                                        comradErrorList[0] &&
                                        comradErrorList[0].patient_lastname &&
                                        comradErrorList[0].patient_lastname?.toLowerCase() !==
                                        orderObj.last_name.toLowerCase() &&
                                        "red",
                                }}
                                error_text={
                                    Array.isArray(comradErrorList) &&
                                    comradErrorList.length > 0 &&
                                    comradErrorList[0] &&
                                    comradErrorList[0].patient_lastname &&
                                    comradErrorList[0].patient_lastname?.toLowerCase() !==
                                    orderObj.last_name.toLowerCase() &&
                                    `Last name in comrad is ${comradErrorList[0].patient_lastname}`
                                }
                            />
                        </td>
                    </tr>

                    <tr>
                        <td style={{ width: "5%", fontSize: "14" }} title={"Date of birth"}>
                            DOB:
                        </td>
                        <td>
                            <Input
                                id="DOB"
                                key="dob"
                                label="DOB"
                                elementType="input"
                                name="DOB"
                                width="90%"
                                textTransform="none"
                                placeholder="dd/mm/yyyy"
                                Value={orderObj.DOB}
                                onChange={(event) => {
                                    inputChangedHandler(event, "DOB");
                                }}
                                customStyle={{
                                    borderColor:
                                        Array.isArray(comradErrorList) &&
                                        comradErrorList.length > 0 &&
                                        comradErrorList[0].patient_dob &&
                                        orderObj.DOB !==
                                        moment(comradErrorList[0].patient_dob).format(
                                            "DD/MM/YYYY"
                                        ) &&
                                        "red",
                                }}
                                error_text={
                                    Array.isArray(comradErrorList) &&
                                    comradErrorList.length > 0 &&
                                    comradErrorList[0].patient_dob &&
                                    orderObj.DOB !==
                                    moment(comradErrorList[0].patient_dob).format(
                                        "DD/MM/YYYY"
                                    ) &&
                                    `DOB in comrad is ${moment(
                                        comradErrorList[0].patient_dob
                                    ).format("DD/MM/YYYY")}`
                                }
                            />
                        </td>

                        <td style={{ width: "5%", fontSize: "14" }} title={"Contact"}>
                            CT:
                        </td>
                        <td>
                        <div style={{display:'flex'}}>
                            <Input
                                id="contact"
                                key="contact_details"
                                label="Contact"
                                elementType="input"
                                name="contact"
                                width="100%"
                                textTransform="none"
                                placeholder="Contact"
                                Value={!orderObj.contact ? "" : orderObj.contact}
                                onChange={(event) => {
                                    inputChangedHandler(event, "contact");
                                }}
                            />
                             <div style={{height:'30px',width:'30px',background:'#fff',border:'1px solid #fefefe',fontSize:'15px',marginLeft:'3px',borderRadius:'5px',textAlign:'center'}}><div style={{padding:'5px'}}>{orderObj?.contact?.includes("+61") ? orderObj?.contact?.length-3 : (orderObj?.contact === null ? 0 : orderObj?.contact?.length) }</div></div>
                             </div>

                        </td>
                    </tr>
                </table>
            </div>

            {workFlowIdentifier === "GP_WORKFLOW" && (
                <Fragment>
                    {(GpServicesToShowDoctorList.includes(
                        gpOrderDetails.gp_requested_service
                    ) ||
                        !gpOrderDetails.gp_requested_service) && (
                            <table style={{ width: "100%", marginTop: "-5px" }}>
                                <tr>
                                    <td
                                        style={{ width: "6.5%", fontSize: "14" }}
                                        title={"Insurance Type"}
                                    >
                                        IT:
                                    </td>
                                    <div style={{ width: "96%" }}>
                                        <SelectBoxDropDown
                                            placeholder="Select a insuranceType "
                                            data={insuranceTypeList}
                                            valueExpr="value"
                                            displayExpr="type"
                                            Value={gpOrderDetails.insuranceType}
                                            changeHandler={
                                                insuranceSelectionHandler
                                                //   (val) =>{
                                                // console.log("CHANGE_HANDLER")
                                                //   setGpOrderDetails({
                                                //     ...gpOrderDetails,
                                                //     insuranceType: val,
                                                //   })

                                                // }
                                            }
                                        />
                                    </div>
                                    <td style={{ width: "3%" }}></td>
                                    <td style={{ fontSize: "14", width: "5%" }} title={"Insurance Number"}>
                                        IN:
                                    </td>
                                    <td style={{ width: "44%" }}>
                                        <Input
                                            width="100%"
                                            placeholder="Insurance Number "
                                            Value={
                                                gpOrderDetails.insuranceType === "CASH"
                                                    ? ""
                                                    : gpOrderDetails.insuranceNumber
                                            }
                                            disabled={
                                                gpOrderDetails.insuranceType === "CASH" ? true : false
                                            }
                                            onChange={(event) =>
                                                setGpOrderDetails({
                                                    ...gpOrderDetails,
                                                    insuranceNumber: event.target.value,
                                                })
                                            }
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ width: "6.5%", fontSize: "14" }} title={"GP Appointment Type"}>
                                        GPAT:
                                    </td>
                                    <td style={{ width: "46%" }}>
                                        <SelectBoxDropDown
                                            placeholder="GP Appointment Type"
                                            data={[
                                                { value: "INCLINIC", label: "In Clinic" },
                                                { value: "TELEHEALTH", label: "Telehealth" },
                                            ]}
                                            valueExpr="value"
                                            displayExpr="label"
                                            Value={gpOrderDetails.gp_appointment_type}
                                            changeHandler={(val) =>
                                                setGpOrderDetails((prev)=> ({
                                                    ...prev,
                                                    gp_appointment_type: val,
                                                }))
                                            }
                                        />
                                    </td>
                                    <td style={{ width: "3%" }}></td>
                                    <td style={{ fontSize: "14", width: "5%" }} title={"Birth sex"}>
                                        BS:
                                    </td>
                                    <td style={{ width: "44%" }}>
                                        <SelectBoxDropDown
                                            placeholder="Birth sex"
                                            data={[
                                                { value: "FEMALE", label: "Female" },
                                                { value: "MALE", label: "Male" },
                                                { value: "OTHER", label: "Other" },
                                                { value: "UNKNOWN", label: "Unknown" },
                                            ]}
                                            valueExpr="value"
                                            displayExpr="label"
                                            Value={gpOrderDetails.birth_sex}
                                            changeHandler={(val) =>
                                                setGpOrderDetails((prev)=> ({
                                                    ...prev,
                                                    birth_sex: val,
                                                }))
                                            }
                                        />
                                    </td>
                                </tr>
                            </table>
                        )}
                    {(gpOrderDetails.bp_appointment_id ||
                        orderObj?.reason_for_manual_booking) && (
                            <Fragment>
                                <div className="section__separation"></div>
                                <ManualBookingResaonContainer>
                                    {orderObj?.reason_for_manual_booking && (
                                        <ManualBookingText>
                                            Reason for manual booking :{" "}
                                            {orderObj?.reason_for_manual_booking?.error_description} [
                                            {orderObj?.reason_for_manual_booking?.error_code}]
                                        </ManualBookingText>
                                    )}
                                    {gpOrderDetails.bp_appointment_id && (
                                        <ManualBookingText>
                                            Slot duration (min):{" "}
                                            {gpOrderDetails.appointment_length
                                                ? gpOrderDetails.appointment_length / 60
                                                : ""}
                                        </ManualBookingText>
                                    )}
                                </ManualBookingResaonContainer>


                            </Fragment>
                        )}


                    {
                        (GpServicesToShowDoctorList.includes(
                            gpOrderDetails.gp_requested_service
                        ) ||
                            !gpOrderDetails.gp_requested_service) && (
                            <Fragment>
                                <div className="section__separation" style={{ marginBottom: "5px" }} ></div>
                                <table style={{ width: "100%" }} >
                                    <tr>
                                        <td
                                            style={{ width: "6%", fontSize: "14" }}
                                            title={"PMS Mobile"}
                                        >
                                            PM:
                                        </td>
                                        <td>
                                            <Input
                                                id="pms_mobile"
                                                key="pms_mobile"
                                                label="PMS Mobile"
                                                elementType="input"
                                                name="contact"
                                                width="92%"
                                                textTransform="none"
                                                placeholder="PMS Mobile"
                                                Value={
                                                    !gpOrderDetails.pms_mobile
                                                        ? ""
                                                        : gpOrderDetails.pms_mobile
                                                }
                                                onChange={(event) => {
                                                    inputChangedHandler(event, "pms_mobile");
                                                }}
                                                customStyle={{
                                                    marginRight: "2px",
                                                }}
                                                disabled={true}
                                            />
                                        </td>
                                        {/* <td style={{width:"3%"}} ></td> */}
                                        <td
                                            style={{ width: "6%", fontSize: "14", marginLeft: "4px" }}
                                            title={"PMS Landline"}
                                        >
                                            PL:
                                        </td>
                                        <td>
                                            <Input
                                                id="pms_landline"
                                                key="pms_landline"
                                                label="PMS Landline"
                                                elementType="input"
                                                name="pms_landline"
                                                width="100%"
                                                textTransform="none"
                                                placeholder="PMS Landline"
                                                Value={
                                                    !gpOrderDetails.pms_landline
                                                        ? ""
                                                        : gpOrderDetails.pms_landline
                                                }
                                                onChange={(event) => {
                                                    inputChangedHandler(event, "pms_landline");
                                                }}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                </table>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        width: "100%",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <div className="pms_id">
                                        <div className="pms_id_text" title="PMS Appointment Id">
                                            PMS Id:
                                        </div>
                                        <div className="pms_id_input">
                                            <Input
                                                fontSize="17px"
                                                width="100%"
                                                placeholder="PMS Id"
                                                Value={gpOrderDetails.bp_appointment_id}
                                                disabled={true}
                                            />
                                        </div>
                                        {gpOrderDetails.bp_appointment_id && (
                                            <div
                                                className="new_existing_patient_text"
                                                style={{
                                                    background:
                                                        gpOrderDetails.bp_appointment_new_patient_created
                                                            ? "#035D91"
                                                            : "#499F4C",
                                                }}
                                            >
                                                {gpOrderDetails.bp_appointment_new_patient_created ? (
                                                    <div>
                                                        {" "}
                                                        {gpOrderDetails?.pms_patient_id ? (
                                                            <p style={{ marginBottom: "0px" }}>
                                                                New patient ({gpOrderDetails.pms_patient_id})
                                                            </p>
                                                        ) : (
                                                            <p style={{ marginBottom: "0px" }}>New patient</p>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div>
                                                        {" "}
                                                        {gpOrderDetails?.pms_patient_id != null ? (
                                                            <p style={{ marginBottom: "0px" }}>
                                                                Existing patient (
                                                                {gpOrderDetails.pms_patient_id})
                                                            </p>
                                                        ) : (
                                                            <p style={{ marginBottom: "0px" }}>
                                                                Existing patient
                                                            </p>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    <div className="checkPatient">
                                        {conversationID != null &&
                                            gpOrderDetails.bp_appointment_id && (
                                                <button
                                                    className="btn btn-primary "
                                                    type="button"
                                                    onClick={() => setPopupVisible(!popupVisible)}
                                                    style={{ padding: "10px 10px" }}
                                                >
                                                    <span
                                                        style={{ fontWeight: "bold", fontSize: "10px" }}
                                                    >
                                                        Check Patient
                                                    </span>
                                                </button>
                                            )}
                                    </div>
                                </div>
                                <div className="section__separation"></div>
                            </Fragment>
                        )}
                    <div className="section__separation" >
                    {
                            gpOrderDetails.conversation_context &&  <div>{gpOrderDetails.conversation_context.replace("_"," ")}</div>
                        }
                    </div>
                    <div className="section__separation" style={{ fontWeight: 500, color: "red" }}>
                        {
                            gpOrderDetails.conversation_tags_data && gpOrderDetails.conversation_tags_data.map((item, i) => {
                                console.log(item)
                                return (
                                    <li>{item?.tag_description}</li>
                                )
                            })
                        }
                        
                    </div>
                    <div className="section__separation">
                        <table style={{ width: "100%", marginTop: "5px" }}>
                            <tr>
                                <td
                                    style={{ fontSize: "14", width: "10px" }}
                                    title={"Call status"}
                                >
                                    Status:
                                </td>
                                <div style={{ width: "100%" }}>
                                    <SelectBoxDropDown
                                        placeholder="Select a status"
                                        valueExpr="operator_feedback"
                                        displayExpr="operator_feedback_english"
                                        data={orderObj.operatorFeedbackOptions}
                                        Value={showCallStatusCode}
                                        changeHandler={(value) => {
                                            setOrderObj({ ...orderObj, ["CallStatusCode"]: value });
                                        }}
                                        onChangeHandler={
                                            (value) => {

                                                setShowCallStatusCode(value)
                                            }
                                        }
                                    />
                                </div>
                            </tr>
                        </table>
                    </div>
                </Fragment>
            )}
        </Fragment>
    );
};

export default GpOrderDetails;
